// Host routes this app sends the merchant to with `portal-router-push`.
// The business profile's brand tab is native: it replaced the `/coin/image` screen.
export const BRAND_TAB_HOST_PATH = '/management/business-info/brand';
